<template>
    <div
        class="kgr-alert kgr-alert--noIcon"
        :class="messageClass"
    >
        <div class="kgr-postfix kgr-postfix--center kgr-postfix--smallGutters">
            <div class="kgr-postfix__fixed">
                <kgr-icon
                    icon-class="info-circle"
                    :small="true"
                />
            </div>
            <div
                v-t="titleKey"
                class="kgr-postfix__fluid kgr-test kgr-text--bold"
            ></div>
        </div>
        <div
            v-if="html"
            v-html="$t(textKey, textParams)"
        ></div>
        <div
            v-else-if="isTranslated"
            v-html="textKey"
        ></div>
        <div v-else>
            {{ $t(textKey, textParams) }}
        </div>
    </div>
</template>

<script>
import Icon from './icon/Icon';

export default {
    components: {
        'kgr-icon': Icon,
    },
    props: {
        titleKey: {
            type: String,
            required: false,
            default: 'NoteBox.title',
        },
        warning: {
            type: Boolean,
            required: false,
            default: false,
        },
        textParams: {
            type: Object,
            required: false,
            default() {
                return {};
            },
        },
        textKey: {
            type: String,
            required: true,
        },
        html: {
            type: Boolean,
            required: false,
            default: false,
        },
        isTranslated: {
            type: Boolean,
            required: false,
            default: false,
        },
    },
    computed: {
        messageClass() {
            if (this.warning) {
                return 'kgr-alert--warning';
            }
            return 'kgr-alert--info';
        },
    },
};
</script>

<style scoped lang="scss" rel="stylesheet/scss">
    div.tooltip-plain {
    margin-bottom: 20px;
}
div.ui-state-highlight div {
    margin: 4px 0;
}
</style>
